export default "__VITE_ASSET__C993WPaG__"